import MainLayout from './main';
import LoginLayout from './login';
import {MasterLayout} from './master';
import {UserLayout} from './user';

export {
  MainLayout,
  LoginLayout,
  MasterLayout,
  UserLayout
}



// WEBPACK FOOTER //
// ./components/layouts/index.js